import { h } from 'preact'
import { useState, memo } from 'preact/compat'
import PropTypes from 'prop-types'
import { findAddress, formatAddress } from '../../../api/billingAddress'
import Input from '../../Common/Input'
import { useTranslations } from '../../../hooks/useTranslations'
import styles from './AddressFinder.module.scss'

const countryCodesMap = {
  GB: 'GBR',
  IE: 'IRL',
}

const getCorrectCountryCode = code => countryCodesMap[code] || 'GBR'

const AddressFinder = ({ onSelect, countryCode = 'GB' }) => {
  const l10n = useTranslations()

  const [value, setValue] = useState('')
  const [addressSuggestions, setAddressSuggestions] = useState([])

  const onInput = e => {
    const address = e.target.value
    if (address) {
      findAddress(address, getCorrectCountryCode(countryCode))
        .then(data => setAddressSuggestions(data.results))
        .catch(error => console.error(error))
    } else {
      setAddressSuggestions([])
    }

    setValue(address)
  }

  const onSelectAddress = format => {
    formatAddress(format)
      .then(data => {
        onSelect(data.address)
        setAddressSuggestions([])
        setValue('')
      })
      .catch(e => console.error(e))
  }

  const reset = () => {
    setValue('')
    setAddressSuggestions([])
  }

  return (
    <div className={styles.addressFinder}>
      <Input
        label={l10n.t('Address finder')}
        inputProps={{
          id: 'addressFinder',
          'data-testid': 'field-input',
          value,
          onInput,
          autoComplete: 'off',
        }}
        reset={reset}
      />

      {Boolean(addressSuggestions?.length) && (
        <div
          className={styles.addressFinder__results}
          data-testid="found-addresses"
        >
          <ul role="listbox" tabIndex="-1">
            {addressSuggestions.map((suggestion, i) => (
              <li key={suggestion.suggestion} role="option">
                <button
                  className={styles.selectButton}
                  data-testid={`button-${i}`}
                  type="button"
                  tabIndex="0"
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      onSelectAddress(suggestion.format)
                    }
                  }}
                  onClick={() => onSelectAddress(suggestion.format)}
                >
                  {suggestion.suggestion}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

AddressFinder.propTypes = {
  onSelect: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
}

export default memo(AddressFinder)
